export interface Address {
  city: string;
  country: COUNTRIES;
  state: STATES;
  street: string;
  zipcode: string;
}

export interface AddressGroup {
  group: string;
  addresses: Address[];
}

export interface AddressListViewModel {
  addressGroups: AddressGroup[];
}

// Could be taken to another file as constants
export enum COUNTRIES {
  US = 'United States',
  AF = 'Afghanistan',
  AX = 'Åland Islands',
  AL = 'Albania',
  DZ = 'Algeria',
  AS = 'American Samoa',
  AD = 'AndorrA',
  AO = 'Angola',
  AI = 'Anguilla',
  AQ = 'Antarctica',
  AG = 'Antigua and Barbuda',
  AR = 'Argentina',
  AM = 'Armenia',
  AW = 'Aruba',
  AU = 'Australia',
  AT = 'Austria',
  AZ = 'Azerbaijan',
  BS = 'Bahamas',
  BH = 'Bahrain',
  BD = 'Bangladesh',
  BB = 'Barbados',
  BY = 'Belarus',
  BE = 'Belgium',
  BZ = 'Belize',
  BJ = 'Benin',
  BM = 'Bermuda',
  BT = 'Bhutan',
  BO = 'Bolivia',
  BA = 'Bosnia and Herzegovina',
  BW = 'Botswana',
  BV = 'Bouvet Island',
  BR = 'Brazil',
  IO = 'British Indian Ocean Territory',
  BN = 'Brunei Darussalam',
  BG = 'Bulgaria',
  BF = 'Burkina Faso',
  BI = 'Burundi',
  KH = 'Cambodia',
  CM = 'Cameroon',
  CA = 'Canada',
  CV = 'Cape Verde',
  KY = 'Cayman Islands',
  CF = 'Central African Republic',
  TD = 'Chad',
  CL = 'Chile',
  CN = 'China',
  CX = 'Christmas Island',
  CC = 'Cocos (Keeling) Islands',
  CO = 'Colombia',
  KM = 'Comoros',
  CG = 'Congo',
  CD = 'Congo, The Democratic Republic of the',
  CK = 'Cook Islands',
  CR = 'Costa Rica',
  HR = 'Croatia',
  CU = 'Cuba',
  CY = 'Cyprus',
  CZ = 'Czech Republic',
  DK = 'Denmark',
  DJ = 'Djibouti',
  DM = 'Dominica',
  DO = 'Dominican Republic',
  EC = 'Ecuador',
  EG = 'Egypt',
  SV = 'El Salvador',
  GQ = 'Equatorial Guinea',
  ER = 'Eritrea',
  EE = 'Estonia',
  ET = 'Ethiopia',
  FK = 'Falkland Islands (Malvinas)',
  FO = 'Faroe Islands',
  FJ = 'Fiji',
  FI = 'Finland',
  FR = 'France',
  GF = 'French Guiana',
  PF = 'French Polynesia',
  TF = 'French Southern Territories',
  GA = 'Gabon',
  GM = 'Gambia',
  GE = 'Georgia',
  DE = 'Germany',
  GH = 'Ghana',
  GI = 'Gibraltar',
  GR = 'Greece',
  GL = 'Greenland',
  GD = 'Grenada',
  GP = 'Guadeloupe',
  GU = 'Guam',
  GT = 'Guatemala',
  GG = 'Guernsey',
  GN = 'Guinea',
  GW = 'Guinea-Bissau',
  GY = 'Guyana',
  HT = 'Haiti',
  HM = 'Heard Island and Mcdonald Islands',
  VA = 'Holy See (Vatican City State)',
  HN = 'Honduras',
  HK = 'Hong Kong',
  HU = 'Hungary',
  IS = 'Iceland',
  IN = 'India',
  ID = 'Indonesia',
  IR = 'Iran, Islamic Republic Of',
  IQ = 'Iraq',
  IE = 'Ireland',
  IM = 'Isle of Man',
  IL = 'Israel',
  IT = 'Italy',
  JM = 'Jamaica',
  JP = 'Japan',
  JE = 'Jersey',
  JO = 'Jordan',
  KZ = 'Kazakhstan',
  KE = 'Kenya',
  KI = 'Kiribati',
  KR = 'Korea, Republic of',
  KW = 'Kuwait',
  KG = 'Kyrgyzstan',
  LV = 'Latvia',
  LB = 'Lebanon',
  LS = 'Lesotho',
  LR = 'Liberia',
  LY = 'Libyan Arab Jamahiriya',
  LI = 'Liechtenstein',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  MO = 'Macao',
  MK = 'North Macedonia',
  MG = 'Madagascar',
  MW = 'Malawi',
  MY = 'Malaysia',
  MV = 'Maldives',
  ML = 'Mali',
  MT = 'Malta',
  MH = 'Marshall Islands',
  MQ = 'Martinique',
  MR = 'Mauritania',
  MU = 'Mauritius',
  YT = 'Mayotte',
  MX = 'Mexico',
  FM = 'Micronesia, Federated States of',
  MD = 'Moldova, Republic of',
  MC = 'Monaco',
  MN = 'Mongolia',
  MS = 'Montserrat',
  MA = 'Morocco',
  MZ = 'Mozambique',
  MM = 'Myanmar',
  NA = 'Namibia',
  NR = 'Nauru',
  NP = 'Nepal',
  NL = 'Netherlands',
  AN = 'Netherlands Antilles',
  NC = 'New Caledonia',
  NZ = 'New Zealand',
  NI = 'Nicaragua',
  NE = 'Niger',
  NG = 'Nigeria',
  NU = 'Niue',
  NF = 'Norfolk Island',
  MP = 'Northern Mariana Islands',
  NO = 'Norway',
  OM = 'Oman',
  PK = 'Pakistan',
  PW = 'Palau',
  PS = 'Palestinian Territory, Occupied',
  PA = 'Panama',
  PG = 'Papua New Guinea',
  PY = 'Paraguay',
  PE = 'Peru',
  PH = 'Philippines',
  PN = 'Pitcairn Islands',
  PL = 'Poland',
  PT = 'Portugal',
  PR = 'Puerto Rico',
  QA = 'Qatar',
  RE = 'Reunion',
  RO = 'Romania',
  RU = 'Russian Federation',
  RW = 'Rwanda',
  SH = 'Saint Helena',
  KN = 'Saint Kitts and Nevis',
  LC = 'Saint Lucia',
  PM = 'Saint Pierre and Miquelon',
  VC = 'Saint Vincent and the Grenadines',
  WS = 'Samoa',
  SM = 'San Marino',
  ST = 'Sao Tome and Principe',
  SA = 'Saudi Arabia',
  SN = 'Senegal',
  CS = 'Serbia and Montenegro',
  SC = 'Seychelles',
  SL = 'Sierra Leone',
  SG = 'Singapore',
  SK = 'Slovakia',
  SI = 'Slovenia',
  SB = 'Solomon Islands',
  SO = 'Somalia',
  ZA = 'South Africa',
  GS = 'South Georgia and the South Sandwich Islands',
  ES = 'Spain',
  LK = 'Sri Lanka',
  SD = 'Sudan',
  SR = 'Suriname',
  SJ = 'Svalbard and Jan Mayen',
  SZ = 'Swaziland',
  SE = 'Sweden',
  CH = 'Switzerland',
  SY = 'Syrian Arab Republic',
  TW = 'Taiwan',
  TJ = 'Tajikistan',
  TZ = 'Tanzania, United Republic of',
  TH = 'Thailand',
  TL = 'Timor-Leste',
  TG = 'Togo',
  TK = 'Tokelau',
  TO = 'Tonga',
  TT = 'Trinidad and Tobago',
  TN = 'Tunisia',
  TR = 'Turkey',
  TM = 'Turkmenistan',
  TC = 'Turks and Caicos Islands',
  TV = 'Tuvalu',
  UG = 'Uganda',
  UA = 'Ukraine',
  AE = 'United Arab Emirates',
  GB = 'United Kingdom',
  UM = 'United States Minor Outlying Islands',
  UY = 'Uruguay',
  UZ = 'Uzbekistan',
  VU = 'Vanuatu',
  VE = 'Venezuela',
  VN = 'Vietnam',
  VG = 'Virgin Islands, British',
  VI = 'Virgin Islands, U.S.',
  WF = 'Wallis and Futuna',
  EH = 'Western Sahara',
  YE = 'Yemen',
  ZM = 'Zambia',
  ZN = 'Zimbabwe',
}

export enum STATES {
  AL = 'Alabama',
  AK = 'Alaska',
  AZ = 'Arizona',
  AR = 'Arkansas',
  CA = 'California',
  CO = 'Colorado',
  CT = 'Connecticut',
  DC = 'District of Columbia',
  DE = 'Delaware',
  FL = 'Florida',
  GA = 'Georgia',
  HI = 'Hawaii',
  ID = 'Idaho',
  IL = 'Illinois',
  IN = 'Indiana',
  IA = 'Iowa',
  KS = 'Kansas',
  KY = 'Kentucky',
  LA = 'Louisiana',
  ME = 'Maine',
  MD = 'Maryland',
  MA = 'Massachusetts',
  MI = 'Michigan',
  MN = 'Minnesota',
  MS = 'Mississippi',
  MO = 'Missouri',
  MT = 'Montana',
  NE = 'Nebraska',
  NV = 'Nevada',
  NH = 'New Hampshire',
  NJ = 'New Jersey',
  NM = 'New Mexico',
  NY = 'New York',
  NC = 'North Carolina',
  ND = 'North Dakota',
  OH = 'Ohio',
  OK = 'Oklahoma',
  OR = 'Oregon',
  PA = 'Pennsylvania',
  RI = 'Rhode Island',
  SC = 'South Carolina',
  SD = 'South Dakota',
  TN = 'Tennessee',
  TX = 'Texas',
  UT = 'Utah',
  VT = 'Vermont',
  VA = 'Virginia',
  WA = 'Washington',
  WV = 'West Virginia',
  WI = 'Wisconsin',
  WY = 'Wyoming',
}

export type StateCode = keyof typeof STATES
export type StateName = typeof STATES
export type CountryCode = keyof typeof COUNTRIES

export const ARRAY_OF_STATES = Object.entries(STATES).map((item) => ({
  id: item[0],
  name: item[1],
}));

/** Non-US countries for international nexus / tax UI. */
export const ARRAY_OF_INTERNATIONAL_COUNTRIES = Object.entries(COUNTRIES)
  .filter(([code]) => code !== 'US')
  .map(([id, name]) => ({
    id,
    name,
  }));

/** Canadian provinces/territories for province-level compliance. */
export const CANADA_PROVINCES: Record<string, { name: string; regime: string; ui_label: string }> = {
  BC: { name: 'British Columbia', regime: 'GST_PST', ui_label: 'British Columbia (PST)' },
  SK: { name: 'Saskatchewan', regime: 'GST_PST', ui_label: 'Saskatchewan (PST)' },
  MB: { name: 'Manitoba', regime: 'GST_RST', ui_label: 'Manitoba (RST)' },
  QC: { name: 'Quebec', regime: 'QST', ui_label: 'Quebec (QST)' },
  ON: { name: 'Ontario', regime: 'HST', ui_label: 'Ontario (HST)' },
  NB: { name: 'New Brunswick', regime: 'HST', ui_label: 'New Brunswick (HST)' },
  NS: { name: 'Nova Scotia', regime: 'HST', ui_label: 'Nova Scotia (HST)' },
  NL: { name: 'Newfoundland and Labrador', regime: 'HST', ui_label: 'Newfoundland and Labrador (HST)' },
  PE: { name: 'Prince Edward Island', regime: 'HST', ui_label: 'Prince Edward Island (HST)' },
  AB: { name: 'Alberta', regime: 'GST', ui_label: 'Alberta (GST)' },
  NT: { name: 'Northwest Territories', regime: 'GST', ui_label: 'Northwest Territories (GST)' },
  NU: { name: 'Nunavut', regime: 'GST', ui_label: 'Nunavut (GST)' },
  YT: { name: 'Yukon', regime: 'GST', ui_label: 'Yukon (GST)' },
};

export const ARRAY_OF_CANADA_PROVINCES = Object.entries(CANADA_PROVINCES).map(([id, meta]) => ({
  id,
  name: meta.ui_label,
  regime: meta.regime,
}));
